import React, { useState, useEffect, useRef, memo, lazy, Suspense, useContext } from 'react';
import { useSelector } from 'react-redux';
import { Formik } from 'formik';
import { PERMISSOES } from '../../common/Constants';
import { PACIENTE } from '@stt-componentes/paciente/dist/lib/form/fieldNames';
import axios from 'axios';
import { getHeaders } from '../../request';
import HttpStatus from 'http-status-codes';
import validationSchema from './validationSchema';
import EnvioImagens from '../../componentes/envio-imagens';
import { temPermissaoRBAC } from '../../secutity/acl';
import {
	SttLoading,
	SttFormHelperText,
	SttCircularProgress,
	SttTranslateHook,
	SttCtrlP
} from '@stt-componentes/core';
import {
	SttAlerta,
	SttContentDrawer
} from '@stt-componentes/core-v2';
import { REACT_KEYS, SECOES } from './fieldNames';
import { CAMPOS_PACIENTE } from './camposPacientes';
import { initialValues } from './initialValues';
import { makeStyles } from '@material-ui/core/styles';
import Utils from '../../utils';
import { NotificationManager } from 'react-notifications';

const Paciente = lazy(() => import('@stt-componentes/paciente'));
const Solicitante = lazy(() => import('../../componentes/solicitacao/solicitante'));
const InformacoesClinicas = lazy(() => import('../../componentes/solicitacao/informacoes-clinicas'));


const Alerta = memo((props) => {
	return <SttAlerta {...props} />;
});

const useStyles = makeStyles((theme) => ({
	fullWidth: {
		width: '100%'
	},
	buttonWrapper: {
		marginTop: theme.spacing(2)
	},
	wrapper: {
		padding: theme.spacing(2)
	}
}));

const campos = CAMPOS_PACIENTE;

const Solicitacao = () => {
	const classes = useStyles();
	const drawerRef = useRef();
	const { strings } = useContext(SttTranslateHook.I18nContext);
	const user = useSelector((state) => state.index.user);

	const schema = validationSchema(strings, campos.camposCadastro);

	const handleCloseAlerta = () => {
		setMostrarAlerta(false);
		abrirSecao('paciente', true);
	};

	const handleAbrirModalEnvioImagens = () => {
		setMostrarAlerta(false);
		setMostrarModalEnvioImagens(temPermissaoRBAC(user, PERMISSOES.CRIAR_EXAME));
	};

	//Envio de imagens
	const [enviarImagens, setEnviarImagens] = useState(false);
	const [mostrarModalEnvioImagens, setMostrarModalEnvioImagens] = useState(false);
	const [solicitacao, setSolicitacao] = useState(false);
	const [mostrarAlerta, setMostrarAlerta] = useState(false);
	const [tituloAlerta, setTituloAlerta] = useState('');
	const [tipoAlerta, setTipoAlerta] = useState('alert');
	const [mensagemAlerta, setMensagemAlerta] = useState('');
	const [opcoesAlerta, setOpcoesAlerta] = useState([
		{
			title: strings.ok,
			onClick: handleCloseAlerta
		}
	]);

	const [secoesAbertas, setSecoesAbertas] = useState({
		paciente: true,
		solicitante: false,
		informacoesClinicas: false
	});

	// Impressão do termo de autorização
	const [confirmarTermo, setConfirmarTermo] = useState(false);
	const [gerarTermo, setGerarTermo] = useState(false);
	const [paciente, setPaciente] = useState(null);
	const [instituicaoSolicitante, setInstituicaoSolicitante] = useState(null);

	const secaoPaciente = useRef(null);
	const secaoSolicitante = useRef(null);
	const secaoInfoClicnicas = useRef(null);

	// Controle do envio de imagens
	const [confirmarEnvioExame, setConfirmarEnvioExame] = useState(false);

	const imprimirTermo = (idPaciente) => {
		Utils.imprimirTcleFn({ id: idPaciente }, () => {
			setPaciente(null);
			setInstituicaoSolicitante(null);
			setGerarTermo(false);
		});
	};

	useEffect(() => {
		if (gerarTermo) {
			imprimirTermo(paciente, instituicaoSolicitante);
		} else {
			setPaciente(null);
			setInstituicaoSolicitante(null);
		}
	}, [gerarTermo]);

	const abrirSecao = (secao, estado) => {
		let novoSecoesAbertas = {
			...secoesAbertas
		};
		for (const secaoAberta in novoSecoesAbertas) {
			novoSecoesAbertas[secaoAberta] = false;
		}
		novoSecoesAbertas[secao] = estado;
		setSecoesAbertas(novoSecoesAbertas);
	};

	const verificarSecoesComErro = (validateForm) => {
		validateForm().then((retorno) => {
			let node = null;

			if (retorno['paciente']) {
				abrirSecao('paciente', true);
				node = secaoPaciente.current;
			} else if (retorno['solicitante']) {
				abrirSecao('solicitante', true);
				node = secaoSolicitante.current;
			} else if (retorno['informacoesClinicas']) {
				abrirSecao('informacoesClinicas', true);
				node = secaoInfoClicnicas.current;
			}

			if (node) {
				setTimeout(() => {
					node.scrollIntoView({
						behavior: 'smooth',
						block: 'center',
						inline: 'start'
					});
				}, 200);
			}
		});
	};

	const callbackImpedirImpressao = () => {
		NotificationManager.error(strings.impressaoDesabilitada);
	};

	return (
		<div className={classes.wrapper}>
			<Formik
				initialValues={initialValues}
				validationSchema={schema}
				onSubmit={(data, { setSubmitting, resetForm }) => {
					setSubmitting(true);
					let dados = { ...data };
					dados.digitador = {
						id: user.idFuncionario
					};
					if (dados.paciente) {
						if (dados.paciente.cpf) {
							dados.paciente.cpf = dados.paciente.cpf.replace(/\D+/g, '');
						}
						if (dados.paciente.cep) {
							dados.paciente.cep = dados.paciente.cep.replace(/\D+/g, '');
						}
					}
					let tipoAlertaSolicitacao = '';
					let tituloAlertaSolicitacao = '';
					let mensagemAlertaSolicitacao = '';

					axios
						.post(`${global.gConfig.url_base_eeg}/solicitacao`, dados, { headers: getHeaders() })
						.then((response) => {
							const dadosSolicitacao = response.data.data;
							const dadosPaciente = dadosSolicitacao.paciente;

							dadosSolicitacao.resultadoExames = dados.informacoesClinicas.resultadoExames;
							dadosSolicitacao.instituicao = dados.solicitante.instituicao;

							setSolicitacao(dadosSolicitacao);
							setPaciente(dadosPaciente);
							setInstituicaoSolicitante(dados.solicitante.instituicao);
							tipoAlertaSolicitacao = 'success';
							setOpcoesAlerta([
								{
									title: strings.ok,
									onClick: () => {
										handleCloseAlerta();
										setConfirmarTermo(true);
									}
								}
							]);
							tituloAlertaSolicitacao = strings.sucesso;
							mensagemAlertaSolicitacao = response.data.message;
							resetForm();
						})
						.catch((err) => {
							const { response } = err;
							let msg = strings.erroDesconhecido;
							if (response) {
								if (response.status === HttpStatus.BAD_REQUEST) {
									const dadosResposta = response.data;
									let arrMensagem = [];
									dadosResposta.errors.forEach((error) => {
										arrMensagem.push(`- ${error.message}`);
									});
									msg = arrMensagem.join('\n');
									tipoAlertaSolicitacao = 'error';
									tituloAlertaSolicitacao = dadosResposta.message;
									mensagemAlertaSolicitacao = msg;
								} else {
									tipoAlertaSolicitacao = 'error';
									tituloAlertaSolicitacao = strings.erro;
									mensagemAlertaSolicitacao = msg;
								}
							} else {
								tipoAlertaSolicitacao = 'error';
								tituloAlertaSolicitacao = strings.erro;
								mensagemAlertaSolicitacao = msg || strings.erroDesconhecido;
							}
							setOpcoesAlerta([
								{
									title: strings.ok,
									onClick: handleCloseAlerta
								}
							]);
						})
						.finally(() => {
							setSubmitting(false);
							setTipoAlerta(tipoAlertaSolicitacao);
							setTituloAlerta(tituloAlertaSolicitacao);
							setMensagemAlerta(mensagemAlertaSolicitacao);
							setMostrarAlerta(true);
						});
				}}
			>
				{({ values, isSubmitting, handleSubmit, errors, touched, submitCount, validateForm, setFieldValue }) => (
					<>
						<SttCtrlP callback={callbackImpedirImpressao} />
						<form onSubmit={handleSubmit} noValidate>
							<SttContentDrawer
								titulo={strings.solicitacaoExame}
								ref={drawerRef}
								secoesErro={[SECOES.DADOS_DO_PACIENTE, SECOES.SOLICITANTE, SECOES.INFORMACOES_CLINICAS]}
								botoes={[
									{
										key: REACT_KEYS.BTN_ENVIAR,
										descricao: strings.enviar,
										salvar: true,
										show: true,
										disabled: isSubmitting,
										onClick: () => drawerRef.current.verificarSecoesComErro(validateForm),
									}
								]}
								conteudo={[
									{
										key: REACT_KEYS.SEC_DADOS_DO_PACIENTE,
										id: SECOES.DADOS_DO_PACIENTE,
										titulo: strings.dadosPaciente,
										show: true,
										children: (
											<>
												<Suspense fallback={<SttCircularProgress color="primary" />}>
													<div ref={secaoPaciente}></div>
													<Paciente
														strings={strings}
														headers={getHeaders()}
														usarTipoContato
														persistirParametrosBusca
														campos={campos}
														imc
														formExterno={{
															paciente: values[PACIENTE],
															setFieldValue,
															errors: errors[PACIENTE],
															submitCount
														}}
													/>

													{touched.paciente && errors.paciente && errors.paciente.nome && (
														<SttFormHelperText error>{strings.pacienteObrigatorio}</SttFormHelperText>
													)}
												</Suspense>
											</>
										)
									},
									{
										key: REACT_KEYS.SEC_SOLICITANTE,
										id: SECOES.SOLICITANTE,
										titulo: strings.solicitante,
										show: true,
										children: (
											<>
												<Suspense fallback={<SttCircularProgress color="primary" />}>
													<div ref={secaoSolicitante}></div>
													<Solicitante />
												</Suspense>
											</>

										)
									},
									{
										key: REACT_KEYS.SEC_INFORMACOES_CLINICAS,
										id: SECOES.INFORMACOES_CLINICAS,
										titulo: strings.infoClinicas,
										show: true,
										children: (
											<>
												<Suspense fallback={<SttCircularProgress color="primary" />}>
													<div ref={secaoInfoClicnicas}></div>
													<InformacoesClinicas />
												</Suspense>
											</>
										)
									},
								]}
							/>
						</form>
						<SttLoading
							open={isSubmitting}
							text={strings.salvandoSolicitacao}
						/>
						<Alerta
							open={mostrarAlerta}
							title={tituloAlerta}
							message={mensagemAlerta}
							type={tipoAlerta}
							options={opcoesAlerta}
							onClose={handleCloseAlerta}
						/>
						<Alerta
							open={confirmarTermo}
							title={strings.termoEsclarecimento}
							message={strings.mensagemConfirmarTermo_solicitacao}
							type={'confirmation'}
							options={[
								{
									title: strings.sim,
									onClick: () => {
										setConfirmarTermo(false);
										setGerarTermo(true);
										if (temPermissaoRBAC(user, PERMISSOES.CRIAR_EXAME)) {
											setConfirmarEnvioExame(true);
										}
									}
								},

								{
									title: strings.nao,
									onClick: () => {
										setConfirmarTermo(false);
										if (temPermissaoRBAC(user, PERMISSOES.CRIAR_EXAME)) {
											setConfirmarEnvioExame(true);
										}
									}
								}
							]}
							onClose={() => {
								setConfirmarTermo(false);
								if (temPermissaoRBAC(user, PERMISSOES.CRIAR_EXAME)) {
									setConfirmarEnvioExame(true);
								}
							}}
						/>
						{temPermissaoRBAC(user, PERMISSOES.CRIAR_EXAME) && (
							<Alerta
								open={confirmarEnvioExame}
								title={strings.tituloConfirmarEnvioExame}
								message={strings.mensagemConfirmarEnvioExame}
								type={'confirmation'}
								options={[
									{
										title: strings.sim,
										onClick: () => {
											setEnviarImagens(true);
											setConfirmarEnvioExame(false);
											handleAbrirModalEnvioImagens();
										}
									},
									{
										title: strings.nao,
										onClick: () => {
											setSolicitacao(false);
											setConfirmarEnvioExame(false);
										}
									}
								]}
								onClose={() => {
									setSolicitacao(false);
									setConfirmarEnvioExame(false);
								}}
							/>
						)}
					</>
				)}
			</Formik >
			{temPermissaoRBAC(user, PERMISSOES.CRIAR_EXAME) && solicitacao && enviarImagens && (
				<EnvioImagens
					modalOpen={mostrarModalEnvioImagens}
					resetFormulario={() => {
						setSolicitacao(false);
						setMostrarModalEnvioImagens(false);
						setEnviarImagens(false);
					}}
					solicitacao={solicitacao}
				/>
			)}
		</div>
	);
};

export default Solicitacao;
